import { Visibility, VisibilityOff } from '@mui/icons-material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import apiManagerUser from 'api/manager-users';
import { IconClose } from 'assets/icons';
import OtpDialog from 'components/Dialog/OtpDialog';
import { COMPONENT_RENDER } from 'constants/common';
import { TOAST_DEFAULT } from 'constants/toast';
import { ERROR } from 'pages/authentication/components/constant';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setCloseModal, setOpenModal } from 'store/modal/modalSlice';
import { setEmail, setExpireTimeOTP } from 'store/user/accountInfo';
import { setUserInfo } from 'store/user/userInfoSlice';
import { color } from 'theme';
import { toastError, toastSuccess } from 'utils/helpers';

export default function ChangeEmail({ closeModal, checkClose, beforeEmailAccount, emailAccount }) {
    const dispatch = useDispatch();
    const [emailUser, setEmailUser] = useState('');
    const [passUser, setPassUser] = useState('');
    const [validValue, setValidValue] = useState({ result: true, text: '' });
    const [showPass, setShowPass] = useState(false);
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const handleClickShowPass = () => setShowPass(!showPass);
    const { t } = useTranslation();

    const handleCancelChangeEmail = () => {
        if (closeModal) {
            dispatch(setCloseModal());
        } else {
            dispatch(setEmail(userInfo?.email));
            dispatch(setCloseModal());
            dispatch(
                setOpenModal({
                    modal: <OtpDialog componentRender={COMPONENT_RENDER.VERIFY_EMAIL} checkClose={checkClose} />,
                    alwayClose: checkClose ? false : true,
                }),
            );
        }
    };

    const sendOTP = (email, page, pass, username) => {
        return apiManagerUser.sendOTP(email, page, pass, username);
    };

    const verifyMail = (email, beforeEmail, otp) => {
        return apiManagerUser.verifyMail(email, beforeEmail, otp);
    };

    const handleSubmitVerifyOtp = (emailAccount, beforeEmailAccount, otp) => {
        verifyMail(emailAccount, beforeEmailAccount, otp)
            .then((res) => {
                toastSuccess(t('toast.verifiedEmail'));
                dispatch(
                    setUserInfo({
                        ...userInfo,
                        email: emailAccount,
                    }),
                );
                dispatch(setCloseModal());
            })
            .catch((error) => {
                if (error.response.data.detail.countDown) {
                    let totalSeconds = error.response.data.detail.countDown;
                    let hours = Math.floor(totalSeconds / 3600);
                    totalSeconds %= 3600;
                    let minutes = Math.floor(totalSeconds / 60);
                    let seconds = totalSeconds % 60;
                    const timeChangePwd = `${t('toast.subChangePwd')} ${
                        hours ? t('toast.subHours', { hour: hours }) : ''
                    }${minutes || hours ? t('toast.subMinutes', { minute: minutes }) : ''}${
                        seconds && minutes === 0 && hours === 0 ? t('toast.subSeconds', { second: seconds }) : ''
                    }`;
                    toastError(timeChangePwd);
                    dispatch(setCloseModal());
                } else {
                    toastError(t(TOAST_DEFAULT.ERROR));
                    dispatch(setCloseModal());
                }
            });
    };

    const handleChangeEmail = () => {
        const username = localStorage.getItem('userName');

        sendOTP(emailUser, 'profile-mail', passUser, username)
            .then((r) => {
                toastSuccess(t('toast.sendOTPSuccess'));
                dispatch(setExpireTimeOTP(r.timeExpire));
                dispatch(setEmail(emailUser));
                dispatch(
                    setOpenModal({
                        modal: (
                            <OtpDialog
                                passUser={passUser}
                                onSubmitVerifyOtp={handleSubmitVerifyOtp}
                                pageSentOtp="profile-mail"
                                title={t('auth.verifyEmail.header')}
                            />
                        ),
                        alwayClose: true,
                    }),
                );
            })
            .catch((error) => {
                if (error?.response?.data?.detail === ERROR.MAX_FORGOT_ACCOUNT) {
                    toastError(t('auth.ERROR.MAX_FORGOT_ACCOUNT'));
                } else if (error?.response?.data?.detail === ERROR.MAX_FORGOT_DEVICE) {
                    toastError(t('auth.ERROR.MAX_FORGOT_DEVICE'));
                } else if (error?.response?.data?.detail === ERROR.NO_EMAIL) {
                    toastError(t('auth.ERROR.NO_EMAIL'));
                } else if (error?.response?.data?.detail === 'EMAIL_EXISTED') {
                    toastError(t('toast.existedEmail'));
                } else if (error?.response?.data?.detail === 'Password not valid') {
                    toastError(t('validate.wrongPassword'));
                } else toastError(t(TOAST_DEFAULT.ERROR));
            });
    };

    const isValidMail = (string) => {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/gim;
        return re.test(string);
    };

    const handleValidEmail = (value) => {
        if (!value) {
            setValidValue({ result: false, text: t('validate.required') });
        } else if (value?.length > 64) {
            setValidValue({ result: false, text: t('validate.maxText') });
        } else if (!isValidMail(value)) {
            setValidValue({ result: false, text: t('validate.mailFormat') });
        } else {
            setValidValue({ result: true, text: '' });
        }
    };

    const handleKeyDown = (e) => {
        if (validValue?.result === false || emailUser?.length === 0 || passUser?.length === 0) {
        } else {
            if (e.key === 'Enter') {
                handleChangeEmail();
            }
        }
    };

    const inputRef = useRef();
    useEffect(() => {
        inputRef.current.value = '';
    }, []);

    return (
        <Box sx={{ display: 'flex', justifyItems: 'center', flexDirection: 'column', margin: '0.5rem 1.5rem 1rem' }}>
            <Box
                sx={{
                    fontSize: { xs: '18px', md: '24px' },
                    margin: '16px 0px 24px',
                    fontWeight: '700',
                    color: '#44494d',
                }}
            >
                {t('popup.change-email.title')}
            </Box>
            <Box>
                <Typography sx={{ marginBottom: '6px' }}>
                    {t('popup.change-email.text')}
                    <span style={{ color: color.main }}>*</span>
                </Typography>
                <TextField
                    name="info-email"
                    inputRef={inputRef}
                    fullWidth
                    value={emailUser}
                    onChange={(e) => {
                        setEmailUser(e.target.value.trim());
                        handleValidEmail(e.target.value.trim());
                    }}
                    inputProps={{
                        autocomplete: 'new-username',
                    }}
                    error={!validValue?.result}
                    helperText={validValue?.text}
                    autoFocus={true}
                    InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                            <InputAdornment position="end">
                                {emailUser !== '' ? (
                                    <IconButton
                                        tabIndex={-1}
                                        aria-label="toggle email visibility"
                                        onClick={() => setEmailUser('')}
                                        sx={{ p: 0.5 }}
                                    >
                                        <IconClose />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                            </InputAdornment>
                        ),
                    }}
                    onKeyDown={handleKeyDown}
                />
            </Box>
            <Box sx={{ marginTop: '30px' }}>
                <Typography sx={{ marginBottom: '6px' }}>
                    {t('popup.change-email.title-pass')}
                    <span style={{ color: color.main }}>*</span>
                </Typography>
                <TextField
                    name="info-password"
                    fullWidth
                    type={showPass ? 'text' : 'password'}
                    value={passUser}
                    onChange={(e) => {
                        setPassUser(e.target.value);
                    }}
                    inputProps={{
                        autoComplete: 'new-password',
                    }}
                    onKeyDown={handleKeyDown}
                    InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                            <InputAdornment position="end">
                                {passUser !== '' ? (
                                    <IconButton
                                        tabIndex={-1}
                                        aria-label="toggle email visibility"
                                        onClick={() => setPassUser('')}
                                        sx={{ p: 0.5 }}
                                    >
                                        <IconClose />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                                <IconButton
                                    tabIndex={-1}
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPass}
                                    sx={{ p: 0.5 }}
                                    // onMouseDown={handleMouseDownPass}
                                >
                                    {showPass ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                <ErrorOutlineOutlinedIcon sx={{ fontSize: '14px', color: '#44494D', marginRight: '5px' }} />
                <Typography>{t('popup.change-email.content')}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '16px' }}>
                <Button variant="outlined" onClick={handleCancelChangeEmail}>
                    {t('popup.change-email.cancel-button')}
                </Button>
                <Button
                    sx={{ marginLeft: '16px' }}
                    disabled={validValue?.result === false || emailUser?.length === 0 || passUser?.length === 0}
                    onClick={() => handleChangeEmail()}
                >
                    {t('popup.change-email.submit-button')}
                </Button>
            </Box>
        </Box>
    );
}
